<template>
<div class="manning-vessel-crew-edit flex w-full justify-start" style="flex-direction: column;">

  <div ref="manningVesselCrewEditForm" style="height: calc(100vh - 220px); overflow-y: scroll; margin: 0 1rem;">

    <div style="margin-top: 1rem;" class="required aisea-text-16-400-black" >
      必要事項を入力してください。「<label></label>」は入力必須項目です。
    </div>

    <!-- 7月末リリースでは、乗船ステータスは選択しない -->
    <!-- 
    <div class="flex w-full justify-start items-start manning-vessel-crew-edit-form-row">
      <div class="flex w-full" style="flex-direction: column;">
        <div class="required" >
          <label class="vs-input--label">乗船ステータス</label>
          <v-select
            placeholder="乗船ステータスを選択してください"
            :disabled="true"
            class="w-full"
            label="name"
            name="boardingStatus"
            :options="boardingStatusList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="localData.boardingStatus"
            v-validate="'required'"
            :clearable="false"
            data-vv-as="乗船ステータス"
          >
            <template v-slot:no-options>乗船ステータスが見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm" style="margin-left: 0.6rem;"
            v-show="errors.has('boarding_status')"
            >{{ errors.first("boarding_status") }}</span
          >
        </div>
        <div style="margin-left: 0.6rem;"></div>
      </div>
    </div>
    -->

    <div class="flex w-full justify-start" style="flex-direction: column;">
      <div class="flex w-full justify-start">
        <div class="flex justify-start items-start manning-vessel-crew-edit-form-row" style="width: 45%;">
          <div class="w-full required" style="position:relative;">
            <label class="vs-input--label">開始日</label>
            <div style="position:absolute; top: 2.2rem; left: 0.8rem; z-index: 9; " >
              <feather-icon
                icon="CalendarIcon"
                svgClasses="h-4 w-4"
                class="calendar-icon"
              />
            </div>
            <datepicker
              name="daytime_in"
              :language="ja"
              :format="formatter"
              :typeable="false"
              placeholder="乗船開始日を選択"
              v-model="localData.daytime_in"
              v-validate="'required'"
              data-vv-as="開始日"
              :disabled-dates="disabledDates"
              ref="datePickerBirthDate"
              @closed="validateForDatetimeRange"
            ></datepicker>
            <span
              class="text-danger text-sm" style="margin-left: 0.6rem;"
              v-show="errors.has('daytime_in')"
              >{{ errors.first("daytime_in") }}</span
            >
          </div>
        </div>

        <div class="flex w-full justify-center" style="width: 10%; padding-top: 3rem;">
          〜
        </div>

        <div class="flex justify-start items-start manning-vessel-crew-edit-form-row" style="width: 45%;">
          <div class="w-full required" style="position:relative;" id="right-date-picker">
            <label class="vs-input--label">終了日</label>
            <div style="position:absolute; top: 2.2rem; left: 0.8rem; z-index: 9; " >
              <feather-icon
                icon="CalendarIcon"
                svgClasses="h-4 w-4"
                class="calendar-icon"
              />
            </div>
            <datepicker
              name="daytime_out"
              :language="ja"
              :format="formatter"
              :typeable="false"
              placeholder="乗船終了日を選択"
              v-model="localData.daytime_out"
              v-validate="'required'"
              data-vv-as="終了日"
              :disabled-dates="disabledDates"
              ref="datePickerBirthDate"
              @closed="validateForDatetimeRange"
            ></datepicker>
            <span
              class="text-danger text-sm" style="margin-left: 0.6rem;"
              v-show="errors.has('daytime_out')"
              >{{ errors.first("daytime_out") }}</span
            >
          </div>
        </div>
      </div>
      <div class="flex w-full justify-start">
        <span
          class="text-danger text-sm" style="margin-left: 0.6rem;"
          v-show="errors.has('daytime_range')"
          >{{ errors.first("daytime_range") }}</span
        >
      </div>
    </div>

    <div class="flex w-full justify-start items-start manning-vessel-crew-edit-form-row">
      <div class="flex w-full"  style="flex-direction: column;">
        <div class="required" >
          <label class="vs-input--label">船名</label>
          <v-select
            name="vessel_name"
            v-model="dispManningVessel"
            :clearable="false"
            :options="dispManningVessels"
            label="disp_name"
            v-validate="'required'"
            data-vv-as="船名"
            placeholder="船名を選択してください"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            @input="onChangeManningVessel"
          >
            <template v-slot:no-options>船情報が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm" style="margin-left: 0.6rem;"
            v-show="errors.has('vessel_name')"
            >{{ errors.first("vessel_name") }}</span
          >
        </div>
        <div style="margin-left: 0.6rem;"></div>
      </div>
    </div>

    <div class="flex w-full justify-start items-start manning-vessel-crew-edit-form-row">
      <div class="flex w-full required" style="flex-direction: column;">
        <label class="vs-input--label">職名</label>
        <v-select
          name="role"
          v-model="localData.role"
          :clearable="false"
          :options='roleList'
          label="dispName"
          v-validate="'required'"
          data-vv-as="職名"
          placeholder="職名を選択してください"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
          @input="onChangeRole"
        >
          <template v-slot:no-options>職名が見つかりません</template>
        </v-select>
        <span
          class="text-danger text-sm" style="margin-left: 0.6rem;"
          v-show="errors.has('role')"
          >{{ errors.first("role") }}</span
        >
      </div>
    </div>

    <div class="flex w-full justify-start items-start manning-vessel-crew-edit-form-row">
      <div class="flex w-full required" style="flex-direction: column;">
        <label class="vs-input--label">承認権限</label>
        <v-select
          placeholder="承認権限を選択してください"
          class="w-full"
          label="name"
          name="approverAuthority"
          :options="isLaborAdminList"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="localData.isLaborAdmin"
          v-validate="'required'"
          data-vv-as="承認権限"
          :clearable="false"
          :disabled="!canSelectApproverAuthority"
        >
          <template v-slot:no-options>承認権限が見つかりません</template>
        </v-select>
        <span
          class="text-danger text-sm" style="margin-left: 0.6rem;"
          v-show="errors.has('approverAuthority')"
          >{{ errors.first("approverAuthority") }}</span
        >
      </div>
    </div>

    <div v-if="inputParam.id !== null" class="flex w-full justify-start items-start manning-vessel-crew-edit-form-row">
      <div class="flex w-full"  style="flex-direction: column;">
        <label class="vs-input--label">最終更新日</label>
        <div class="flex w-full justify-start items-center" style="height: 2.6rem; border-radius: 4px; border: 1px dotted silver; padding: 0 0.6rem;">
          <div class="aisea-text-16-400-black" :style="{ color: AISEA_COLOR.SLIGHTLY_GRAY }">{{ localData.dispUpdatedAt }}</div>
        </div>
      </div>
    </div>

  </div>


  <vs-divider style="margin: 0;" />

  <div class="flex w-full justify-end items-center">
    <div style="margin: 0.8rem;" >
      <vs-button type="flat" style="width: 6rem; padding: 0.4rem;" :style="{ 'background-color': AISEA_COLOR.WHITE, }" @click="onCancel" :color="AISEA_COLOR.GRAY" >キャンセル</vs-button>
    </div>    
    <div style="margin: 0.8rem;" >
      <vs-button style="width: 6rem; padding: 0.4rem;" @click="onSubmit" :disabled="$refs.dialogUploadProfileImage && $refs.dialogUploadProfileImage.isCrop || !validateForm" :color="AISEA_COLOR.BLUE" >保存</vs-button>
    </div>    
  </div>

</div>
</template>

<script>
import Vue from "vue";
import moment from 'moment-timezone';
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewManningVesselApi = AiseaApiFactory.get("enterpriseCrewManningVessel");

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("crewManningVessels");
const { mapState: mapStateOfCrewAccount } = createNamespacedHelpers("crewAccount");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";


export default {
  name: "ManningVesselCrewEdit",
  components: {
    vSelect,
    Datepicker,
  },
  mixins: [DatepickerMixin, DeviceInfoMixin, ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data() {
    return {
      avatar: null,
      avatarText: "",
      localData: {
      },
      dispManningVessel: null,
      disabledDates: {
        // from: new Date(),
      },
      canSelectApproverAuthority: false,
    };
  },
  computed: {
    ...mapState({
      manningVessels: state => state.manningVessels,
      crewRoles: state => state.crewRoles,
      boardingStatusList: state => state.boardingStatusList,
      isLaborAdminList: state => state.isLaborAdminList,
    }),
    ...mapStateOfCrewAccount({
      crewAccount: state => state.crewAccount,
    }),
    dispManningVessels() {
      return JSON.parse(JSON.stringify(this.manningVessels)).map( manningVessel => {
        manningVessel['disp_name'] = manningVessel.name_ja || manningVessel.name;
        return manningVessel;
      });
    },
    roleList() {
      return this.crewRoles.map(role => {
        role.dispName = this.$t('Views.Crew.' + role['localized_key']);
        return role;
      }).filter( x => x.dispName );
    },
    validateForm() {
      return !this.errors.any() && this.localData.boardingStatus  && this.localData.daytime_in && this.localData.daytime_out && this.localData.role &&  this.localData.dispManningVessel && this.localData.isLaborAdmin ;
    },
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
  },
  methods: {

    initLocalData() {
      this.avatar = null;
      this.avatarText = '';

      if ( this.inputParam.id  ) {

        this.localData = JSON.parse(JSON.stringify(this.inputParam));

        this.localData.dispUpdatedAt = this.localData.updated_at ? moment(this.localData.updated_at).local().format("YYYY/MM/DD HH:mm:ss") : null;
        this.localData.dispManningVessel = this.dispManningVessels.find(x => x.id ===  this.localData.vessel.id );
        this.dispManningVessel = this.localData.dispManningVessel;
        this.localData.role = this.inputParam.roles.length > 0 ? this.roleList.find(x => x.id === this.inputParam.roles[0].id ) : null;
        // this.localData.boardingStatus = this.boardingStatusList.find(x => x.id ===  this.localData.boarding_status );
        this.localData.boardingStatus = this.boardingStatusList.find(x => x.id === '1' ); // 7月末リリースでは、"乗船"固定
        this.localData.isLaborAdmin = this.isLaborAdminList.find(x => x.id ===  this.localData.is_labor_admin );

        if ( ["chief_engineer", "chief_officer"].includes(this.localData.role.localized_key) ) {
          this.canSelectApproverAuthority = true;
        }

      } else {
        this.localData = {};
        this.localData.boardingStatus = this.boardingStatusList.find( x => x.id === '1' ); // 7月末リリースでは、"乗船"固定
      }
    },

    validateForDatetimeRange() {

      this.$validator.errors.remove('daytime_range');
      if ( ! this.localData.daytime_in || ! this.localData.daytime_out ) {
        return true;
      }
      if ( moment(this.localData.daytime_in).startOf('days').valueOf() > moment(this.localData.daytime_out).startOf('days').valueOf() ) {
        this.$validator.errors.add({
          field: 'daytime_range',
          msg: '終了日は開始日よりも未来に設定してください。'
        })
        return false;
      }
      return true;
    },

    onChangeManningVessel(val) {
      this.localData.dispManningVessel = val;
    },

    onChangeRole(val) {
      console.debug("### onChangeRole", val);
      this.canSelectApproverAuthority = true;
      if ( ["captain"].includes(val.localized_key)  ) {
        this.localData.isLaborAdmin = this.isLaborAdminList.find(x => x.id === 1) ;
        this.canSelectApproverAuthority = false;
      } else if ( ["chief_engineer", "chief_officer"].includes(val.localized_key)  ) {
        this.localData.isLaborAdmin = this.isLaborAdminList.find(x => x.id === 0) ;
        this.canSelectApproverAuthority = true;
      } else {
        this.localData.isLaborAdmin = this.isLaborAdminList.find(x => x.id === 0) ;
        this.canSelectApproverAuthority = false;
      }
    },

    scrollEndAdjust() {
      setTimeout(() => {
        this.$refs.manningVesselCrewEditForm.scrollTop = this.$refs.manningVesselCrewEditForm.scrollHeight;
      }, 200);
    },
    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    async onSubmit() {
      let checkValidate = await this.$validator.validateAll();
      let checkvalidateForDatetimeRange = this.validateForDatetimeRange();
      if ( !checkValidate || !checkvalidateForDatetimeRange ) {
        return false;
      }

      const dispId = moment(this.localData.daytime_in).local().format('YYYY/MM/DD') + '〜' + moment(this.localData.daytime_out).local().format('YYYY/MM/DD');

      let payload = {
        boarding_status: this.localData.boardingStatus && !isNaN(this.localData.boardingStatus.id) ? Number(this.localData.boardingStatus.id) : null,
        daytime_in: this.localData.daytime_in ? moment(this.localData.daytime_in).format('YYYY-MM-DD') : null,
        daytime_out: this.localData.daytime_out ? moment(this.localData.daytime_out).format('YYYY-MM-DD') : null,
        enterprise_crew_role_ids: [this.localData.role.id],
        enterprise_manning_vessel_id: this.localData.dispManningVessel.id,
        is_labor_admin: this.localData.isLaborAdmin ? this.localData.isLaborAdmin.id : null,
        version: this.localData.version || 0,
      };



      if ( this.inputParam.id  ) {
        console.debug("### 更新API", this.crewAccount.id, this.inputParam.id, payload);

        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
          const res =  await enterpriseCrewManningVesselApi.update(this.crewAccount.id, this.inputParam.id, payload);
          this.$vs.loading.close();

          if ( res.status ) {
            this.$vs.notify({
              title: `船員乗船期間設定`,
              text: `${dispId}の乗船期間を更新しました`,
              color: "success",
              iconPack: "feather",
              icon: "icon-check"
            });
          } else {
            Vue.$log.warn("error at enterpriseCrewManningVesselApi.update() ", this.crewAccount.id, this.inputParam.id, payload, res);

            this.$vs.notify({
              title: `船員乗船期間設定`,
              text: `${dispId}の乗船期間を更新できませんでした`,
              color: "warning",
              iconPack: "feather",
              icon: "icon-check"
            });

          }
        } catch (e) {
          Vue.$log.warn("error at enterpriseCrewManningVesselApi.update() ", this.crewAccount.id, this.inputParam.id, payload, e);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${dispId}の乗船期間を更新できませんでした`,
            color: "warning",
            iconPack: "feather",
            icon: "icon-check"
          });
        }


      } else {
        console.debug("### 登録API", this.crewAccount.id, payload);

        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
          const res =  await enterpriseCrewManningVesselApi.add(this.crewAccount.id, payload);
          this.localData.id = res.data.id;
          this.$vs.loading.close();

          if ( res.status ) {
            this.$vs.notify({
              title: `船員乗船期間設定`,
              text: `${dispId}の乗船期間を登録しました`,
              color: "success",
              iconPack: "feather",
              icon: "icon-check"
            });
          } else {
            Vue.$log.warn("error at enterpriseCrewManningVesselApi.add() ", this.crewAccount.id, payload, res);
            this.$vs.notify({
              title: `船員乗船期間設定`,
              text: `${dispId}の乗船期間を登録できませんでした`,
              color: "warning",
              iconPack: "feather",
              icon: "icon-check"
            });
          }
        } catch (e) {
          Vue.$log.warn("error at enterpriseCrewManningVesselApi.add() ", this.crewAccount.id, payload, e);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${dispId}の乗船期間を登録できませんでした`,
            color: "warning",
            iconPack: "feather",
            icon: "icon-check"
          });
        }

      }
      this.$emit("updatedId", this.localData.id );
      this.localData = {};

      this.$nextTick(() => {
        this.$emit('reloadList');
        this.$emit('close');
      });
    },
  },
  created() {
    this.initLocalData();
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.manning-vessel-crew-edit {

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger),1);
    }
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2.0rem;
    }
  }

  .vdp-datepicker__calendar {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .selected{
      background: $aisea-blue !important;
    }
  }

  .manning-vessel-crew-edit-form-row {
    flex-direction: column;
    margin: 1rem 0;
    padding-right : 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: $aisea-light-gray;
      font-size: smaller;
    }
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  #right-date-picker {
    .vdp-datepicker__calendar {
      right: 0;
    }
  }
}
</style>
